import type { TConta } from '@/features/proposta/services/get-pessoa-juridica-por-cnpj'
import { HttpService } from '@/infra'
import type { TCliente } from '@/types/cliente'

export type TGetPropostaCompradoresDuplicarResponse = Array<{
  cliente: TCliente | null
  conta: TConta | null
}>

export class GetPropostaCompradoresDuplicarService extends HttpService {
  async execute(numero: number) {
    return this.http.get<TGetPropostaCompradoresDuplicarResponse>(`api/v2/Proposta/${numero}/compradores-duplicar`)
  }
}
